
<template>

  <img class="block w-full max-w-[200px] mx-auto" src="../images/activity-2-part-1-gas.png" alt="Gasoline canister" />

  <p class="mt-6 text-neutral-700">
    
    Not every service station on your route will let you fill up.
    
    It's a good idea to bring your own in case you end up in a tricky situation.
  
  </p>

</template>
